import { createSortOption } from "@nosto/preact"
export const sizes = [96]

export const sortOptions = [
    createSortOption("score", "Mest relevante", { field: "score", order: "desc" }),
    createSortOption("price", "Laveste pris", { field: "price", order: "asc" }),
    createSortOption("-price", "Høyeste pris", { field: "price", order: "desc" }),
    createSortOption("datePublished", "Nyeste", { field: "datePublished", order: "desc" }),
    createSortOption("discount", "Høyeste rabatt", { field: "onDiscount", order: "desc" })
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 10,
    historySize: 10
}

export const whitelistedProductIds = [
    "7353797509317",
    "8139223531717",
    "8311370318021",
]
